import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { FixedSizeList } from 'react-window';
import { GeozoneListItem } from './item';
export function GeozoneList(props) {
    const { geozones, onGeozoneSelect, onOpenGeozoneProperties, onDeleteGeozone } = props;
    function renderRow(props) {
        const geozone = props.data[props.index];
        return (_jsx("div", { style: { ...props.style, listStyleType: 'none' }, children: _jsx(GeozoneListItem, { index: geozone._id, type: geozone.geojson.geometry.type, color: geozone.geojson.properties
                    ? geozone.geojson.properties.style.color
                    : '#3388ff', onChangeIndex: onGeozoneSelect, name: geozone.geojson.properties
                    ? geozone.geojson.properties.name
                    : '', onOpenProperties: onOpenGeozoneProperties, onDelete: onDeleteGeozone }, geozone._id) }));
    }
    return (_jsx(FixedSizeList, { className: "ui-map-draw-geozone-list", height: 600, width: 600, itemCount: geozones.length, itemSize: 50, itemData: geozones, children: renderRow }));
}
